import { supabase } from '@/lib/supabase';

export interface RawPostRow {
  id: string;
  content: string;
  created_at: string;
  user_id: string;
  visibility: string;
  media_url: string | null;
  media_type: string | null;
  profiles:
    | {
        full_name: string | null;
        belt_rank: string | null;
        profile_picture_url: string | null;
        username: string | null;
        main_academy_id: string | null;
        is_instructor: boolean | null;
        is_premium: boolean | null;
        profession: string | null;
        academies: { name: string } | { name: string }[] | null;
        profile_hobbies: { hobby: { name: string } | null }[];
      }
    | {
        full_name: string | null;
        belt_rank: string | null;
        profile_picture_url: string | null;
        username: string | null;
        main_academy_id: string | null;
        is_instructor: boolean | null;
        is_premium: boolean | null;
        profession: string | null;
        academies: { name: string } | { name: string }[] | null;
        profile_hobbies: { hobby: { name: string } | null }[];
      }[]
    | null;
}

export const postsRepository = {
  async getPosts(page: number, pageSize: number): Promise<RawPostRow[]> {
    const { data, error } = await supabase
      .from('posts')
      .select(`
        id,
        content,
        created_at,
        user_id,
        visibility,
        media_url,
        media_type,
        profiles (
          full_name,
          belt_rank,
          profile_picture_url,
          username,
          main_academy_id,
          is_instructor,
          is_premium,
          profession,
          academies!main_academy_id(name),
          profile_hobbies(hobby:hobbies(name))
        )
      `)
      .order('created_at', { ascending: false })
      .range(page * pageSize, (page + 1) * pageSize - 1);

    if (error) throw error;
    return (data ?? []) as unknown as RawPostRow[];
  },

  async deletePost(postId: string): Promise<void> {
    const { error } = await supabase.rpc('delete_post_and_related', {
      post_uuid: postId,
    });
    if (error) throw error;
  },
};
